import { Grid, Box as MuiBox } from '@mui/material';
import ConfirmationWithBackButton from 'src/components/Compliance/ConfirmationWithBackButton';
import RectangleBox from 'src/components/Compliance/RectangleBox';
import BadgeImg from '../../assets/images/GreenStairs.png';
import RedExclamationMark from '../../assets/images/RedExclamationMark.png';
import ErrorCircle from '../../assets/images/error_24px.svg';

const NoPolicyLocated = () => {
  const coverages = [
    'Active Policy',
    'Correct Address',
    'Personal Liability Coverage',
    'Personal Property Coverage',
    'Medical Coverage',
  ]
  return (
    <MuiBox>
      <ConfirmationWithBackButton
        icon={RedExclamationMark}
        title="Sorry, we were unable to locate your policy."
        subtitle="We cannot verify your policy at this time. Please contact your landlord to provide them with a copy of your insurance policy directly."
        image={BadgeImg}
        goBackLink="/compliance/welcome"
        message=<Grid container margin="auto" justifyContent="center">
          <Grid item xs={12} md={9} lg={7}>
            <Grid container flexDirection="column" gap={3}>
              <RectangleBox
                statusIcon={
                  <img
                    src={ErrorCircle}
                    height="30px"
                    width="30px"
                    alt="ErrorCircle"
                  />
                }
                propertyName="We could not find your policy"
                propertyValue="There is problem locating your policy."
              />
              {coverages.map(coverageText => <div key={coverageText} style={{ opacity: 0.6 }}>
                <RectangleBox
                  statusIcon={
                    <img
                      src={ErrorCircle}
                      height="30px"
                      width="30px"
                      alt="ErrorCircle"
                    />
                  }
                  propertyName={coverageText}
                  propertyValue=""
                />
              </div>)}
            </Grid>
          </Grid>
        </Grid>
      />
    </MuiBox>
  );
};

export default NoPolicyLocated;
